import { ProfessionalState } from './_types';

export const initialState: ProfessionalState = {
    organization: null,
};
